import styled from "styled-components";

export const Container = styled.div`
  background-color: #f8f8f8;
  padding: 20px;
  width: 100%;
`;

export const TemplateHeader = styled.h3`
  font-family: "Nunito";
  font-size: 20px;
  font-weight: 500;
  margin-top: 20px;
  border-bottom: 1px solid #293134;
  width: 100%;
  margin-bottom: 10px;
`;

export const CustomLabel = styled.label`
  font-family: "Nunito";
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 0px;
`;

export const InputFile = styled.label`
  width: 100%;
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 300;
  border: none;
  &:focus {
    outline: none;
    border: none;
  }
`;

export const OptionsButton = styled.button`
  width: 220px;
  height: 40px;
  background-color: #f0f0f0;
  border: none;
  font-family: "Nunito";

  &:hover {
    background-color: #f0292a;
    color: #fff;
  }
`;

export const DownloadFileButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;

  &:hover {
    outline: none;
    border: none;
  }
  &:focus {
    outline: none;
    border: none;
  }
  &:active {
    outline: none;
    border: none;
  }
`;

export const GridGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
`;

export const CustomTr = styled.tr`
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 25px;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
